import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { removeProposedAsset as removeProposedAssetApi } from '@api/assetsRent';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_RENT_REQUEST_CARD_ITEMS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateRemoveProposedAssetApi = (id: string, onSuccessCallbacks: Array<() => void>) => {
	const dispatch = useAppDispatch();

	const { mutate: removeProposedAsset } = useMutation<{ assetId: string }>({
		mutationKey: [ASSET_RENT_REQUEST_CARD_ITEMS, id],
		mutationFn: ({ assetId }: { assetId: string }) => removeProposedAssetApi(assetId),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetRentRemoveProposalItem,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallbacks.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}
		},
	});

	return { removeProposedAsset };
};
